module.exports = __webpack_public_path__ + "static/img/201.d2b3d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/201.jpg
// module id = EIHN
// module chunks = 0